<div class="card-download">
    <div class="card-download__image">
      <img loading="lazy" class="banner" [src]="imgUrl +  bizCard?.shop_banner" alt="" /> 
      <div class="shop-shadow">
       <div class="shop-img">
          <img loading="lazy" src="{{ imgUrl }}{{ bizCard?.shop_logo }}" [alt]="bizCard?.shop_name" />
        </div> 
      </div>
    </div>
    <div class="card-download__middle">
      <div class="name">
        {{ bizCard?.shop_name }}
      </div>
      @if(bizCard?.shop_description | nullCheck) {
      <div class="desc-shop">
        {{ bizCard?.shop_description | nullCheck }}
      </div>
      }
    </div>
    <div class="card-download__end">
      <ul class="links">
        <li *ngIf="bizCard?.w_phone_number">
          <div class="icon">
            <i class="fa-brands fa-whatsapp"></i>
          </div>
          <div class="text">
            {{ bizCard?.w_phone_number }}
          </div>
        </li>

        
      </ul>
      
    </div>
    <div class="qr-website">
      <qrcode [elementType]="elementType" [qrdata]="window.location.href.replaceAll('biz/shop', 'share')"
        [errorCorrectionLevel]="'M'"></qrcode> 
      <div class="text">Website</div>
    </div>
</div>



